/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionsQueryResponse, FilesControllerGetFileRenditionsPathParams, FilesControllerGetFileRenditionsQueryParams, FilesControllerGetFileRenditions401, FilesControllerGetFileRenditions403 } from "../../models/filesController/FilesControllerGetFileRenditions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetFileRenditions } from "../../clients/filesService/filesControllerGetFileRenditions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetFileRenditionsQueryKey = (id: FilesControllerGetFileRenditionsPathParams["id"], params: FilesControllerGetFileRenditionsQueryParams = {}) => [{
  url: '/api/v1/files/:id/renditions',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerGetFileRenditionsQueryKey = ReturnType<typeof filesControllerGetFileRenditionsQueryKey>;
export function filesControllerGetFileRenditionsQueryOptions(id: FilesControllerGetFileRenditionsPathParams["id"], params?: FilesControllerGetFileRenditionsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetFileRenditionsQueryKey(id, params);
  return queryOptions<FilesControllerGetFileRenditionsQueryResponse, ResponseErrorConfig<FilesControllerGetFileRenditions401 | FilesControllerGetFileRenditions403>, FilesControllerGetFileRenditionsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetFileRenditions(id, params, config);
    }
  });
}

/**
 * @summary Get file renditions for a file
 * {@link /api/v1/files/:id/renditions}
 */
export function useFilesControllerGetFileRenditions<TData = FilesControllerGetFileRenditionsQueryResponse, TQueryData = FilesControllerGetFileRenditionsQueryResponse, TQueryKey extends QueryKey = FilesControllerGetFileRenditionsQueryKey>(id: FilesControllerGetFileRenditionsPathParams["id"], params?: FilesControllerGetFileRenditionsQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetFileRenditionsQueryResponse, ResponseErrorConfig<FilesControllerGetFileRenditions401 | FilesControllerGetFileRenditions403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetFileRenditionsQueryKey(id, params);
  const query = useQuery({
    ...filesControllerGetFileRenditionsQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerGetFileRenditions401 | FilesControllerGetFileRenditions403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}